// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_32-1";
export var movingGradient = "_32-4";
export var movingGradientBlock = "_32-2";
export var skeleton = "_32-0";
export var skeletonText = "_32-3";